module.exports = __webpack_public_path__ + "static/media/iphone_14_space_black_pro_max.f7c1c048.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_space_black_pro_max.jpg
// module id = 2138
// module chunks = 0